/* Signal Flow — Take One · interactions
   - mobile nav toggle
   - video poster -> lightbox
   - FAQ accordion
   - "draw a card" widget
*/
(function () {
  'use strict';

  var CATS = {
    start:       { label: 'START',       icon: '○' },
    constraint:  { label: 'CONSTRAINT',  icon: '□' },
    perspective: { label: 'PERSPECTIVE', icon: '△' },
    momentum:    { label: 'MOMENTUM',    icon: '→' },
    finish:      { label: 'FINISH',      icon: '●' }
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // **bold** -> <strong>, everything else escaped
  function richText(raw) {
    var segs = String(raw == null ? '' : raw).split('**');
    var out = '';
    for (var i = 0; i < segs.length; i++) {
      out += (i % 2 === 1) ? '<strong>' + esc(segs[i]) + '</strong>' : esc(segs[i]);
    }
    return out;
  }

  function cardHTML(c) {
    var cat = CATS[c.cat] || CATS.start;
    return '' +
      '<div class="sf-card">' +
        '<div class="sf-card__top">' +
          '<div class="sf-card__cat">' +
            '<span class="sf-card__icon">' + cat.icon + '</span>' +
            '<span class="sf-card__label">' + cat.label + '</span>' +
          '</div>' +
          '<span class="sf-card__index">' + esc(c.index) + '</span>' +
        '</div>' +
        '<div class="sf-card__body">' +
          '<div class="sf-card__text">' + richText(c.text) + '</div>' +
          (c.note ? '<p class="sf-card__note">' + esc(c.note) + '</p>' : '') +
        '</div>' +
        '<div class="sf-card__foot">' +
          '<span class="sf-card__sig">Signal Flow</span>' +
          '<span class="sf-card__flip">Flip for notes</span>' +
        '</div>' +
      '</div>';
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ----- mobile nav ----- */
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
      });
    }

    /* ----- video lightbox ----- */
    var modal = document.querySelector('[data-video-modal]');
    if (modal) {
      var openers = document.querySelectorAll('[data-video-open]');
      var closers = modal.querySelectorAll('[data-video-close]');
      var vid = modal.querySelector('video');
      var open = function () {
        modal.hidden = false; document.body.style.overflow = 'hidden';
        if (vid) { try { vid.currentTime = 0; vid.muted = false; var p = vid.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
      };
      var close = function () {
        modal.hidden = true; document.body.style.overflow = '';
        if (vid) { try { vid.pause(); } catch (e) {} }
      };
      Array.prototype.forEach.call(openers, function (b) { b.addEventListener('click', open); });
      Array.prototype.forEach.call(closers, function (b) { b.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    }

    /* ----- FAQ accordion ----- */
    var faqs = document.querySelectorAll('[data-faq]');
    Array.prototype.forEach.call(faqs, function (item) {
      var btn = item.querySelector('[data-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        var sign = item.querySelector('[data-faq-sign]');
        var ans = item.querySelector('[data-faq-a]');
        if (sign) sign.textContent = open ? '–' : '+';
        if (ans) ans.hidden = !open;
        btn.setAttribute('aria-expanded', open);
      });
    });

    /* ----- quantity stepper ----- */
    var qtyWraps = document.querySelectorAll('[data-qty]');
    Array.prototype.forEach.call(qtyWraps, function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      var step = function (delta) {
        var min = parseInt(input.min, 10);
        if (isNaN(min)) min = 0;
        var val = (parseInt(input.value, 10) || min) + delta;
        if (val < min) val = min;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
      if (wrap.hasAttribute('data-qty-auto-submit')) {
        input.addEventListener('change', function () {
          var form = input.closest('form');
          if (!form) return;
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    });

    /* ----- draw a card ----- */
    var draw = document.querySelector('[data-draw]');
    if (draw) {
      var poolEl = document.getElementById('sf-draw-pool');
      var slot = draw.querySelector('[data-draw-slot]');
      var btn = draw.querySelector('[data-draw-btn]');
      var pool = [];
      try { pool = JSON.parse(poolEl.textContent); } catch (e) {}
      if (btn && slot && pool.length) {
        btn.addEventListener('click', function () {
          var pick = pool[Math.floor(Math.random() * pool.length)];
          slot.innerHTML = '<div style="width:260px; animation:sfFlip 0.5s ease both;">' + cardHTML(pick) + '</div>';
          btn.textContent = 'Try Another';
        });
      }
    }
  });
})();